<template>
    <div id="report_builder" class="pb-5">
        <reorder-element-popup-component></reorder-element-popup-component>

        <div class="col">
            <div v-if="!!data_sources_and_accounts" class="row mb-3">
                <div class="col-10 px-0 mb-2">
                    <h4 class="title margin-bottom15">Connected Data Sources</h4>
                    <div>
                        <div class="connected-data-sources">
                            <div class="row">
                                <div class="col source-icon-container px-0">
                                    <span v-for="(dsAndAccount, index) in data_sources_and_accounts">
                                        <img :src="$store.state.app_url + 'images/data_sources/' + dsAndAccount.abbreviation + '.png'" />
                                        <span class="data-source-name">{{ dsAndAccount.name }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-2 date-selection-group">
                    <label>Default date</label>
                    <v-select :clearable="false" v-model="time_period_grouping_id" :reduce="period => period.id" label="name" :options="time_period_groupings"></v-select>
                </div>
            </div>

            <div class="row mb-5">
                <div id="report_build_overview" class="col-12">
                    <div class="row">
                        <div class="col">
                            <div class="row margin-bottom10">
                                <div class="col-8 px-0 align-self-center">
                                    <h4 class="my-0">Report: {{ report.name }}</h4>
                                </div>

                                <div class="col-2 px-0 align-self-center text-right">
                                    <button v-if="$store.getters.getBuilderElements.length > 1" @click="reorderElements" type="button" class="btn btn-info reverse">Reorder Elements</button>
                                </div>
                            </div>

                            <div class="row">
                                <div v-if="$store.getters.getBuilderElements.length === 0" class="col-10 align-self-center">
                                    <div>
                                        <h4 class="text-center margin-bottom0">Start Creating Your Report</h4>
                                    </div>
                                </div>

                                <div v-else class="col-10 px-0 builder-elements">
                                    <template v-for="element in $store.getters.getBuilderElements">
                                        <div :class="{'missed_metrics':missing_metrics_infos && _.has(missing_metrics_infos, element.report_element_id)}">
                                            <div>
                                                <h5 v-if="!/^Element_[0-9]{13}$/.test(element.name)" class="pull-left" :class="element_name_by_id[element.element_id]">{{ element.name }}</h5>

                                                <div class="dropdown">
                                                    <button class="btn dropdown-toggle pull-right" type="button" id="element_options" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        <i class="fa fa-ellipsis-h element-options-icon" aria-hidden="true"></i>
                                                    </button>

                                                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="element_options">
                                                        <a @click="editBuilderElement(element)" class="dropdown-item" href="javascript:void(0)">Edit</a>
                                                        <a @click="duplicateBuilderElement(element)" class="dropdown-item" href="javascript:void(0)">Duplicate</a>
                                                        <a @click="deleteBuilderElement(element.name)" class="dropdown-item" href="javascript:void(0)">Delete</a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="report-element-preview text-center">
                                                <img :src="$store.state.app_url + 'images/report_element_preview/' + element.element_abbreviation + '.jpg'">
                                            </div>

                                            <div class="selected-metrics margin-top20">
                                                <template v-if="element.element_abbreviation === 'social_kpi' || element.element_abbreviation === 'social_campaign_details'">
                                                    <div v-if="!!element.metrics_1 && element.metrics_1.length > 0">
                                                        <h5>Instagram</h5>
                                                        <b class="margin-right20" v-for="metric in element.metrics_1">
                                                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                            {{ metric.new_metric_name || metric.metric_name }}
                                                        </b>
                                                    </div>

                                                    <div v-if="!!element.metrics_2 && element.metrics_2.length > 0" class="margin-top25">
                                                        <h5>Facebook</h5>
                                                        <b class="margin-right20" v-for="metric in element.metrics_2">
                                                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                            {{ metric.new_metric_name || metric.metric_name }}
                                                        </b>
                                                    </div>

                                                    <div v-if="!!element.metrics_3 && element.metrics_3.length > 0" class="margin-top25">
                                                        <h5>Linkedin</h5>
                                                        <b class="margin-right20" v-for="metric in element.metrics_3">
                                                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                            {{ metric.new_metric_name || metric.metric_name }}
                                                        </b>
                                                    </div>
                                                </template>

                                                <template v-else-if="['triple_table_grouping', 'double_table_grouping', 'single_table_grouping', 'single_table_grouping_blue'].indexOf(element.element_abbreviation) === -1">
                                                    <b class="margin-right20" v-for="metric in element.metrics">
                                                        <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                        {{ metric.new_metric_name || metric.metric_name }} ({{ metric.data_source_abbr }})
                                                    </b>
                                                </template>

                                                <template v-else>
                                                    <div v-if="!!element.metrics_1 && element.reporting_table_type_1">
                                                        <h5>{{ element.table_name_1 ? element.table_name_1 + ' - ' : '' }}{{ element.reporting_table_type_1 }}</h5>
                                                        <b class="margin-right20" v-for="metric in element.metrics_1">
                                                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                            {{ metric.new_metric_name || metric.metric_name }} ({{ metric.data_source_abbr }})
                                                        </b>
                                                    </div>

                                                    <div v-if="!!element.metrics_2 && element.reporting_table_type_2" class="margin-top25">
                                                        <h5>{{ element.table_name_2 ? element.table_name_2 + ' - ' : '' }}{{ element.reporting_table_type_2 }}</h5>
                                                        <b class="margin-right20" v-for="metric in element.metrics_2">
                                                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                            {{ metric.new_metric_name || metric.metric_name }} ({{ metric.data_source_abbr }})
                                                        </b>
                                                    </div>

                                                    <div v-if="element.reporting_table_type_3" class="margin-top25">
                                                        <h5>{{ element.table_name_3 ? element.table_name_3 + ' - ' : '' }}{{ element.reporting_table_type_3 }}</h5>
                                                        <b class="margin-right20" v-for="metric in element.metrics_3">
                                                            <i class="fa fa-line-chart" aria-hidden="true"></i>
                                                            {{ metric.new_metric_name || metric.metric_name }} ({{ metric.data_source_abbr }})
                                                        </b>
                                                    </div>
                                                </template>
                                            </div>

                                            <div v-for="show_config in element.show_configs" class="margin-top15">
                                            <span v-if="!(show_config.label === 'Filter' && show_config.value === 'No Filtering')">
                                                <b>{{ show_config.label }}:</b> {{ show_config.value }}
                                            </span>
                                            </div>
                                            <label class="hide-element" @click="showHideElement(element)">
                                                <p-input class="p-default p-curve single" type="checkbox" :value="element.hide_element" :checked="element.hide_element"> Hide</p-input>
                                            </label>
                                        </div>
                                    </template>
                                </div>

                                <div class="col-2 existing-reports margin-top15">
                                    <label>Select a report</label>
                                    <input v-model="search_report" placeholder="Search for a report..." type="search" class="form-control">

                                    <hr class="margin-x0 margin-y10">

                                    <div>
                                        <ul class="list-group">
                                            <li v-for="rep in reports" @click="" class="list-group-item padding-x10 padding-y5" :class="{ 'active': rep.id === report.id }">{{ rep.name }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-8 offset-1 justify-content-center">
                    <div class="row">
                        <template v-for="(element, index) in elements" v-if="element.abbreviation !== 'empty'">
                            <div v-if="index === 6 || index === 12" class="col-12"></div>

                            <div @click="openBuilderPopup(element.id)" class="col elements-body open px-0" :class="isElementSocialAndNoSocialAccountConnected(element.name) ? 'disabled' : ''">
                                <div class="col element-item">
                                    <div class="chart-img-and-title">
                                        <div v-if="element.abbreviation != 'page_break'" class="simple-svg-wrapper">
                                            <!-- Temp solution as there are no icons -->
                                            <simple-svg v-if="no_svg_icon_elements.indexOf(element.abbreviation) === -1" :filepath="$store.state.app_url + 'images/report_icons/' + element.abbreviation + '.svg'" :height="'5rem'"/>
                                            <simple-svg v-else :filepath="$store.state.app_url + 'images/report_icons/topline_stats.svg'" :height="'5rem'"/>
                                        </div>
                                        <div v-else>
                                            <svg height="50" width="50">
                                                <line x1="0" y1="24" x2="50" y2="24" style="stroke:#36a8cd;stroke-width:2" />
                                            </svg>
                                        </div>

                                        <div class="chart-title">{{ element.name.toUpperCase() }}</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>

            <div class="row margin-top30">
                <div class="col-10 text-center">
                    <button :disabled="$store.getters.getBuilderElements.length === 0" @click="buildAndSave" class="btn btn-success btn-lg">Build & Save</button>
                </div>
            </div>
        </div>

        <!-- Elements -->
        <kpi-boxes-component :key="re_render_element_component" v-if="element.abbreviation === 'topline_stats'"></kpi-boxes-component>
        <adwords-visuals-component :key="re_render_element_component" v-if="element.abbreviation === 'adwords_text_ads'"></adwords-visuals-component>
        <report-highlights-component :key="re_render_element_component" v-if="element.abbreviation === 'report_highlights'"></report-highlights-component>
        <updates-and-insights-component :key="re_render_element_component" v-if="element.abbreviation === 'updates_insights'"></updates-and-insights-component>
        <triple-table-grouping-component :key="re_render_element_component" v-if="element.abbreviation === 'triple_table_grouping'"></triple-table-grouping-component>
        <double-table-grouping-component :key="re_render_element_component" v-if="element.abbreviation === 'double_table_grouping'"></double-table-grouping-component>
        <single-table-grouping-component :key="re_render_element_component" v-if="element.abbreviation === 'single_table_grouping'"></single-table-grouping-component>
        <single-table-grouping-blue-component :key="re_render_element_component" v-if="element.abbreviation === 'single_table_grouping_blue'"></single-table-grouping-blue-component>
        <advertising-visuals-component :key="re_render_element_component" v-if="element.abbreviation === 'advert_visuals'"></advertising-visuals-component>
        <traffic-trends-component :key="re_render_element_component" v-if="element.abbreviation === 'traffic_trends'"></traffic-trends-component>
        <top-social-ad-creatives-component :key="re_render_element_component" v-if="element.abbreviation === 'top_social_ad_creatives'"></top-social-ad-creatives-component>
        <social-kpi-component :key="re_render_element_component" v-if="element.abbreviation === 'social_kpi'"></social-kpi-component>
        <social-organic-campaign-details-component :key="re_render_element_component" v-if="element.abbreviation === 'social_campaign_details'"></social-organic-campaign-details-component>
        <social-organic-instagram-grid-component :key="re_render_element_component" v-if="element.abbreviation === 'social_organic_instagram_grid'"></social-organic-instagram-grid-component>
        <social-organic-performance-highlights-component :key="re_render_element_component" v-if="element.abbreviation === 'social_organic_performance_highlights'"></social-organic-performance-highlights-component>
        <social-key-takeaways-component :key="re_render_element_component" v-if="element.abbreviation === 'social_key_takeaways'"></social-key-takeaways-component>
        <key-takeaways-component :key="re_render_element_component" v-if="element.abbreviation === 'key_takeaways'"></key-takeaways-component>
        <text-box-component :key="re_render_element_component" v-if="element.abbreviation === 'commentary'"></text-box-component>
        <heading-component :key="re_render_element_component" v-if="element.abbreviation === 'heading'"></heading-component>
        <metric-glossary-component :key="re_render_element_component" v-if="element.abbreviation === 'metric_glossary'"></metric-glossary-component>
        <page-break-component :key="re_render_element_component" v-if="element.abbreviation === 'page_break'"></page-break-component>
    </div>
</template>

<script>
    import KpiBoxesComponent                           from './elements/KpiBoxesComponent.vue';
    import AdwordsVisualsComponent                     from './elements/AdwordsVisualsComponent.vue';
    import ReportHighlightsComponent                   from './elements/ReportHighlightsComponent.vue';
    import UpdatesAndInsightsComponent                 from './elements/UpdatesAndInsightsComponent.vue';
    import TripleTableGroupingComponent                from './elements/TripleTableGroupingComponent.vue';
    import DoubleTableGroupingComponent                from './elements/DoubleTableGroupingComponent.vue';
    import SingleTableGroupingComponent                from './elements/SingleTableGroupingComponent.vue';
    import SingleTableGroupingBlueComponent            from './elements/SingleTableGroupingBlueComponent.vue';
    import AdvertisingVisualsComponent                 from './elements/AdvertisingVisualsComponent.vue';
    import TrafficTrendsComponent                      from './elements/TrafficTrendsComponent.vue';
    import TopSocialAdCreativesComponent               from './elements/TopSocialAdCreativesComponent.vue';
    import SocialKpiComponent                          from './elements/SocialKpiComponent.vue';
    import SocialOrganicCampaignDetailsComponent       from './elements/SocialOrganicCampaignDetailsComponent.vue';
    import SocialOrganicInstagramGridComponent         from './elements/SocialOrganicInstagramGridComponent.vue';
    import SocialOrganicPerformanceHighlightsComponent from './elements/SocialOrganicPerformanceHighlightsComponent.vue';
    import SocialKeyTakeawaysComponent                 from './elements/SocialKeyTakeawaysComponent.vue';
    import KeyTakeawaysComponent                       from './elements/KeyTakeawaysComponent.vue';
    import TextBoxComponent                            from './elements/TextBoxComponent.vue';
    import HeadingComponent                            from './elements/HeadingComponent.vue';
    import MetricGlossaryComponent                     from './elements/MetricGlossaryComponent.vue';
    import PageBreakComponent                          from './elements/PageBreakComponent.vue';
    import ReorderElementPopupComponent                from './ReorderElementPopupComponent.vue';

    export default {
        created() {
            this.$store.commit('resetBuilderData');
            this.fetchServerData();

            this.no_svg_icon_elements = [
                'advert_visuals',
                'adwords_text_ads',
                'top_social_ad_creatives',
                'social_kpi',
                'social_campaign_details',
                'social_organic_instagram_grid',
                'social_organic_performance_highlights'
            ];
            event_bus.$on('element_saved', () => {
                this.builder_data = JSON.parse(JSON.stringify(this.$store.getters.getBuilderElements));
            });
            event_bus.$on('missed_metrics', (data) => {
                this.missing_metrics_infos = data;
            });
        },

        data() {
            return {
                search_report:               '',
                reports:                     [],
                report:                      {},
                data_sources_and_accounts:   {},
                element:                     {},
                elements:                    [],
                elements_connected:          [],
                element_name_by_id:          {},
                builder_data:                null,
                time_period_groupings:       [],
                time_period_grouping_id:     3,
                re_render_element_component: 0,
                is_already_clicked:          false,
                missing_metrics_infos:       null
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/reports'),
                    axios.get(`/api/reports/${this.$route.params.id}`),
                    axios.get(`/api/reports/data-sources-and-accounts/${this.$route.params.id}`),
                    axios.get('/api/time-period-groupings'),
                    axios.get('/api/elements'),
                    axios.get(`/api/reports/builder?report_id=${this.$route.params.id}`)
                ])
                .then(axios.spread((reports, report, dataSourcesAndAccounts, timePeriodGroupings, elements, builderData) => {
                    this.reports                   = reports.data;
                    this.report                    = report.data;
                    this.time_period_grouping_id   = report.data.time_period_grouping_id || 3;
                    this.data_sources_and_accounts = dataSourcesAndAccounts.data['accounts'][this.$route.params.id];
                    this.elements_connected        = dataSourcesAndAccounts.data['elements'];
                    this.time_period_groupings     = timePeriodGroupings.data;
                    this.elements                  = elements.data;

                    _.each(builderData.data, data => {
                        this.$store.commit('addBuilderElement', data);
                    });

                    _.each(this.$store.getters.getBuilderElements, (el) => {
                        const element = _.find(this.elements, {id: el.element_id});
                        if(!_.has(this.element_name_by_id, el.element_id)){
                            this.element_name_by_id[el.element_id] = element.name.replace(/\s+/gm,'');
                        }
                    })
                    this.builder_data = JSON.parse(JSON.stringify(this.$store.getters.getBuilderElements));
                }));
            },

            showHideElement(element){
                const index = _.findIndex(this.builder_data, {report_element_id: element.report_element_id});
                this.builder_data[index].hide_element = !this.builder_data[index].hide_element;
                this.$store.commit('setBuilderElements', this.builder_data);
            },
            openBuilderPopup(elementId) {
                axios.all([
                    axios.get(`/api/element/${elementId}`),
                    axios.get(`/api/data_sources/report/${this.$route.params.id}/element/${elementId}`),
                    axios.get(`/api/indexes/${this.report.client_id}`)
                ])
                .then(axios.spread((element, dataSources, indexes) => {
                    this.element = element.data;
                    let has_indexes = false;
                    _.each(this.element.element_configurations, (config) => {
                        if(config.config_short_name == 'select_index_name'){
                            config.config_values = _.values(indexes.data);
                            has_indexes = !!config.config_values.length;
                        }
                    });

                    this.$store.commit('setBuilderPopupParams', {
                        client_id:    this.report.client_id,
                        element:      this.element,
                        data_sources: dataSources.data,
                        has_indexes: has_indexes
                    });

                    ++this.re_render_element_component;

                    this.$nextTick(() => {
                        $('#builder_modal').modal('show');
                    })
                }));
            },

            generateElementName() {
                return 'Element_' + Date.now();
            },

            isElementSocialAndNoSocialAccountConnected(elementName) {
                const element = _.find(this.elements, {name: elementName});
                const isText = ['text', 'empty', 'break'].includes(element.element_type_name);
                const socialElements = [
                    'Top Social Ad Creatives',
                    'Social KPI',
                    'Social Organic Campaign Details',
                    'Social Organic Instagram Grid',
                    'Social Organic Performance Highlights',
                    'Social Key Takeaways'
                ];

                const mapping = {
                    'Facebook/Instagram Ads': [
                        'Top Social Ad Creatives',
                        'Social KPI',
                        'Social Key Takeaways'
                    ],

                    'Facebook Insights': [
                        'Social Organic Campaign Details',
                        'Social Organic Performance Highlights',
                        'Social Key Takeaways'
                    ],

                    'Instagram': [
                        'Social Organic Campaign Details',
                        'Social Organic Instagram Grid',
                        'Social Organic Performance Highlights',
                        'Social Key Takeaways'
                    ],
                    'Linkedin': [
                        'Social KPI',
                    ],
                };

                const checkSocialExists = () => {
                    let exists = false;

                    _.each(this.data_sources_and_accounts, value => {
                        if (value.name === 'Facebook/Instagram Ads' && mapping['Facebook/Instagram Ads'].indexOf(elementName) > -1) {
                            return exists = true;

                        } else if (value.name === 'Facebook Insights' && mapping['Facebook Insights'].indexOf(elementName) > -1) {
                            return exists = true;

                        } else if (value.name === 'Instagram' && mapping['Instagram'].indexOf(elementName) > -1) {
                            return exists = true;
                        }
                        else if (value.name === 'LinkedIn Ads' && mapping['Linkedin'].indexOf(elementName) > -1) {
                            return exists = true;
                        }
                    });

                    return exists;
                }

                return isText ? false : !_.has(this.elements_connected, elementName)  || (socialElements.indexOf(elementName) > -1 && !checkSocialExists());
            },

            editBuilderElement(elementData) {
                axios.all([
                    axios.get(`/api/element/${elementData.element_id}`),
                    axios.get(`/api/data_sources/report/${this.$route.params.id}/element/${elementData.element_id}`),
                    axios.get(`/api/indexes/${this.report.client_id}`)
                ])
                .then(axios.spread((element, dataSources, indexes) => {
                    this.element = element.data;
                    let has_indexes = false;
                    _.each(this.element.element_configurations, (config) => {
                        if(config.config_short_name == 'select_index_name'){
                            config.config_values = _.values(indexes.data);
                            has_indexes = !!config.config_values.length;
                        }
                    });
                    const data = {
                        name:                                           /^Element_[0-9]{13}$/.test(elementData.name) ? '' : elementData.name,
                        original_name:                                  elementData.name,
                        selected_metrics:                               elementData.metrics,
                        table_name_1:                                   elementData.table_name_1,
                        table_name_2:                                   elementData.table_name_2,
                        table_name_3:                                   elementData.table_name_3,
                        reporting_table_type_1:                         elementData.reporting_table_type_1,
                        reporting_table_type_2:                         elementData.reporting_table_type_2,
                        reporting_table_type_3:                         elementData.reporting_table_type_3,
                        selected_metrics_1:                             elementData.metrics_1,
                        selected_metrics_2:                             elementData.metrics_2,
                        selected_metrics_3:                             elementData.metrics_3,
                        configurations:                                 elementData.configurations,
                        extra_data:                                     elementData.extra_data,
                        reporting_table_type_configurations_selected_1: elementData.reporting_table_type_configurations_1,
                        reporting_table_type_configurations_selected_2: elementData.reporting_table_type_configurations_2,
                        reporting_table_type_configurations_selected_3: elementData.reporting_table_type_configurations_3,
                        commentary:                                     (elementData.element_abbreviation == 'commentary') ? elementData.commentary : ''
                    };

                    this.$store.commit('setBuilderPopupParams', {
                        client_id:    this.report.client_id,
                        element:      element.data,
                        data_sources: dataSources.data,
                        data:         data,
                        edit_mode:    true,
                        has_indexes:  has_indexes
                    });

                    ++this.re_render_element_component;

                    this.$nextTick(() => {
                        $('#builder_modal').modal('show');
                    });
                }));
            },
            duplicateBuilderElement(elementData){
                let clonedElementData = JSON.parse(JSON.stringify(elementData));
                let index;
                if(_.has(elementData, 'report_element_id')){
                    index = _.findIndex(this.builder_data, function(o) { return o.report_element_id == clonedElementData.report_element_id});
                }
                else{
                    index = _.findIndex(this.builder_data, function(o) { return o.name == clonedElementData.name});
                }
                if(index > -1){
                    const el = _.has(clonedElementData, 'report_element_id') ? _.omit(clonedElementData, ['report_element_id']) : clonedElementData;
                    el.name = clonedElementData.name + ' copy';
                    this.builder_data.splice(index + 1, 0, el);
                    this.$store.commit('setBuilderElements', this.builder_data);

                    this.builder_data = JSON.parse(JSON.stringify(this.$store.getters.getBuilderElements));
                }
            },
            deleteBuilderElement(elementName) {
                this.$store.commit('removeBuilderElement', elementName);
            },

            reorderElements() {
                $('#reorder_elements_modal').modal('show');
            },

            buildAndSave() {
                const vueInstance = this;
                if(this.is_already_clicked){
                    return;
                }
                this.is_already_clicked = true;

                let builderElements = vm.customClone(this.$store.getters.getBuilderElements);

                _.each(builderElements, element => {
                    if (element.element_abbreviation === 'social_kpi') {
                        let concatenation = [];

                        if(!!element.metrics_1){
                            concatenation = concatenation.concat(element.metrics_1);
                            delete element.metrics_1;
                        }
                        if(!!element.metrics_2){
                            concatenation = concatenation.concat(element.metrics_2);
                            delete element.metrics_2;
                        }
                        if(!!element.metrics_3){
                            concatenation = concatenation.concat(element.metrics_3);
                            delete element.metrics_3;
                        }

                        element.metrics = concatenation;
                    }

                    if (element.element_abbreviation === 'social_campaign_details') {
                        element.metrics = element.metrics_1.concat(element.metrics_2);

                        delete element.metrics_1;
                        delete element.metrics_2;
                    }

                    if (element.extra_data) {
                        element.extra_data = JSON.stringify(element.extra_data);
                    }
                });

                axios.post('/api/reports/builder', {
                    report_id: this.$route.params.id,
                    time_period_grouping_id: this.time_period_grouping_id,
                    data: builderElements
                })
                .then(response => {
                    _.each(response.data, (element, report_element_id) => {
                        const el = _.find(this.$store.getters.getBuilderElements, function(o) { return o.name == element.name;});
                        let data = Object.assign({}, el);

                        data.report_element_id = report_element_id;

                        this.$store.commit('updateBuilderElement', {
                            name: el.name,
                            data: data
                        });
                    });

                    this.$notify({
                        type: 'success',
                        text: 'Report has been successfully saved.'
                    });

                    setTimeout(function(){
                        vueInstance.is_already_clicked = false;
                    }, 2000)
                });
            }
        },

        components: {
            'kpi-boxes-component':                             KpiBoxesComponent,
            'adwords-visuals-component':                       AdwordsVisualsComponent,
            'report-highlights-component':                     ReportHighlightsComponent,
            'updates-and-insights-component':                  UpdatesAndInsightsComponent,
            'triple-table-grouping-component':                 TripleTableGroupingComponent,
            'double-table-grouping-component':                 DoubleTableGroupingComponent,
            'single-table-grouping-component':                 SingleTableGroupingComponent,
            'single-table-grouping-blue-component':            SingleTableGroupingBlueComponent,
            'advertising-visuals-component':                   AdvertisingVisualsComponent,
            'traffic-trends-component':                        TrafficTrendsComponent,
            'top-social-ad-creatives-component':               TopSocialAdCreativesComponent,
            'social-kpi-component':                            SocialKpiComponent,
            'social-organic-campaign-details-component':       SocialOrganicCampaignDetailsComponent,
            'social-organic-instagram-grid-component':         SocialOrganicInstagramGridComponent,
            'social-organic-performance-highlights-component': SocialOrganicPerformanceHighlightsComponent,
            'social-key-takeaways-component':                  SocialKeyTakeawaysComponent,
            'key-takeaways-component':                         KeyTakeawaysComponent,
            'text-box-component':                              TextBoxComponent,
            'heading-component':                               HeadingComponent,
            'metric-glossary-component':                       MetricGlossaryComponent,
            'page-break-component':                            PageBreakComponent,
            'reorder-element-popup-component':                 ReorderElementPopupComponent
        }
    }
</script>

<style lang="scss">
    @import '~@/_variables.scss';
    #report_builder {
        h4 {
            font-weight: 400;
        }

        div.missed_metrics{
            border:solid red;
        }
        #builder_modal {
            .metrics-list-selections {
                li {
                    cursor: pointer;
                    border-radius: 0!important;

                    &.active {
                        background-color: #36a8cd;
                        border-color: white;
                        cursor: auto;
                    }

                    &:not(.active):hover {
                        background-color: #eee;
                    }
                }

                > div {
                    max-height: 23.9rem;
                    min-height: 3.5rem;
                    overflow: auto;
                }
            }

            .metrics-list-selected {
                li {
                    border-radius: 0!important;
                    height: 3.4rem;

                    .fa-times,
                    .fa-pencil,
                    .fa-check,
                    .fa-info-circle {
                        font-size: 1.6rem;
                        position: relative;
                        top: .2rem;
                        cursor: pointer;
                    }

                    .fa-info-circle {
                        font-size: 1.6rem;
                        position: relative;
                        top: .1rem;
                        cursor: auto;
                    }

                    .fa-sort {
                        font-size: 1.4rem;
                        position: relative;
                        top: .4rem;
                        cursor: move;
                    }

                    .metric-edit {
                        width: 22.5rem;
                        display: inline-block;
                        height: 2.2rem;
                        border: none;
                        padding-left: 0;
                    }
                }

                > div {
                    max-height: 23.9rem;
                    min-height: 3.5rem;
                    overflow: auto;
                }

                .selected-metrics-title {
                    margin-top: 1.9rem;
                }
            }

            .pretty.p-default input:checked ~ .state label:after {
                background-color: #37a8cd !important;
            }

            .pretty label {
                font-size: 1.3rem;
            }

            .modal-footer {
                button {
                    margin: 0 auto;
                }
            }
        }

        .elements-body {
            box-shadow: 0rem 0rem 2.4rem 0rem rgba(0, 0, 0, 0.04);

            &.open {
                max-height: 63rem;
                background: white;
            }

            &.disabled {
                opacity: .6;
                pointer-events: none;
            }

            > div {
                overflow: hidden;
            }

            .element-item {
                text-align: center;
                padding-top: 1.375rem;
                padding-bottom: 1.375rem;
                border: 1px solid #eeeeee;
                height:100%;

                &:hover {
                    border: 1px solid transparent;
                    box-shadow: 0px 0.6rem 2.2rem 0px rgba(0, 0, 0, 0.08);
                    z-index:9;
                }

                .chart-img-and-title {
                    cursor: pointer;

                    .chart-title {
                        margin-top: 1.5rem;
                        color: #333;
                        font-size: 1.1rem;
                        font-weight: 500;
                    }
                }
            }
        }

        .existing-reports {
            max-height: 30.7rem;
            min-height: 3.5rem;
            overflow: auto;
            position: relative;
            top: -4.7rem;

            li {
                cursor: pointer;
                border-radius: 0!important;

                &.active {
                    background-color: #36a8cd;
                    border-color: white;
                    cursor: auto;
                }

                &:not(.active):hover {
                    background-color: #eee;
                }
            }
        }

        .connected-data-sources {
            padding: 0 1rem;

            div.source-icon-container {
                img {
                    width: 3rem;
                }

                span.data-source-name{
                    font-size: 1.2rem;
                    font-weight: 500;
                    margin-right: 1rem;
                }
            }
        }

        .builder-elements {
            .report-element-preview {
                clear: both;
                padding: 1rem 0 2rem;

                img {
                    max-height: 32rem;
                    max-width:100%;
                }
            }

            #element_options {
                border: none!important;
                padding: 0;
                box-shadow: none!important;
            }

            .dropdown-menu {
                box-shadow: 0 0 0.3rem #73b9cf;
                border: none!important;
            }

            .dropdown-toggle::after {
                display: none!important;
            }

            > div {
                background-color: white;
                padding: 1.5rem;
                box-shadow: 0 0 0.3rem #73b9cf;
                margin-bottom: 1rem;
                position: relative;
            }

            .element-options-icon {
                font-size: 2.8rem;
                color: #37a8cd;
                margin-top: -1rem;
                cursor: pointer;
            }

            .selected-metrics {
                font-size: 1.2rem;
                max-width:90%;
                .fa-line-chart {
                    color: #37a8cd;
                }
                b {
                    font-weight: 500;
                    &:last-child{
                        white-space:nowrap;
                    }
                }
            }
        }
        label.hide-element{
            float:right;
            margin-top:-1rem;
            .pretty.p-default input:checked ~ .state label::after {
                background-color: $secondary !important;
            }
        }
    }
</style>
